import { LocalisedTextAnimated } from '../LocalisedTextAnimated';
import { Shine } from '../Shine';
import { NineSliceButton } from './NineSliceButton';

const defaultOpts = {
    bg: 'yellow' as 'yellow' | 'magenta' | 'red' | 'green' | 'grey',
    text: '',
    fontSize: 70,
    w: 350,
    h: 130,
    startHidden: false,
    wobble: false,
    shining: false,
    stroke: 10,
};

export type RectangleButtonOpts = typeof defaultOpts;

export class RectangleButton extends NineSliceButton
{
    public label: LocalisedTextAnimated;
    protected shine?: Shine;

    constructor(opts: Partial<RectangleButtonOpts> = {})
    {
        const o = { ...defaultOpts, ...opts };
        
        const text = new LocalisedTextAnimated(o.text, {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            stroke: 0x333333,
            strokeThickness: o.stroke,
            lineJoin: 'round',
            align: 'center',
            fontSize: o.fontSize,
            maxWidth: o.w * 0.85,
        });
        text.animate = o.wobble;

        super({
            icon: text,
            accessibleTitle: o.text,
            bgAsset: `button-ninesliced-${o.bg}`,
            w: opts.w,
            h: opts.h,
            startHidden: o.startHidden,
        });
        
        this.label = text;
        this.label.setText(o.text);

        if (o.shining) this.startShining();
    }

    public get text(): string
    {
        return this.label.text;
    }

    public set text(v: string)
    {
        this.label.setText(v);
        this.label.accessibleTitle = v;
    }

    public startWobble(): void
    {
        this.label.animate = true;
    }

    public stopWobble(): void
    {
        this.label.animate = false;
    }

    public startShining(): void
    {
        if (!this.shine) this.shine = new Shine();
        this.view.addChild(this.shine);
        this.shine.x = (this.bg.width / 2) - 23;
        this.shine.y = -(this.bg.height / 2) + 23;
        this.shine.scale.set(2);
        this.shine.visible = true;
    }

    public stopShining(): void
    {
        if (!this.shine) return;
        this.shine.visible = false;
    }
}
